import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { BoxContainer } from '@/components';
import StatsBlock from './StatsBlock/StatsBlock';
import Slider from './Slider/Slider';
import styles from './index.module.scss';

export type ExtendedTestimonialsProps =
  SliceComponentProps<Content.ExtendedTestimonialsSlice>;

const ExtendedTestimonials: FC<ExtendedTestimonialsProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <BoxContainer styles={styles.wrapper}>
        <StatsBlock slice={slice} />
        <Slider slice={slice} />
      </BoxContainer>
    </section>
  );
};

export default ExtendedTestimonials;
